<template>
  <div class="h5DeviceWrap">
    <Live v-if="token && no" :isWebview="true" />
    <pageToast v-else :msg="msg" />
  </div>
</template>

<script>
import Live from "./../live/live.vue";
let count = 0
export default {
  components: {
    Live
  },
  data () {
    return {
      no: "",
      token: "",
      msg: ""
    }
  },
  async created () {
    const timer = setInterval(() => {
      if (window.sse) {
        window.sse.close()
        clearInterval(timer)
      }
      if (count > 20) {
        clearInterval(timer)
        count = 0
      }
      count++
    }, 1000)



    sessionStorage.setItem("isWebview", true)
    const query = this.$route.query
    let { token, no } = query
    if (!token) {
      this.msg = "登录信息不能为空"
    } else if (!no) {
      this.msg = "设备编号不能为空"
    } else {
      localStorage.setItem("token", token)
      // 查询所有设备  看这个设备是否存在
      await this.$api.getDeviceList().then(res => {
        let state = false
        if (res.errcode === 0) {
          const data = res.data || []
          const target = data.find(o => String(o.no) === String(no))
          if (target) {
            state = true
          } else {
            state = false
          }
        }

        if (!state) {
          this.msg = `设备编号${no}不存在`
          this.no = undefined
          this.token = undefined
          localStorage.setItem("no", "")
          localStorage.setItem("token", "")
        } else {
          this.no = no
          this.token = token
          localStorage.setItem("no", no)
          localStorage.setItem("token", token)

        }
      })
    }
  }
}
</script>

<style lang="scss">
.h5DeviceWrap {
  height: 100%;
}
</style>
